import _ from 'underscore';

import { normalize, freshDefaults } from '@invintusmedia/preference-model-manager';

import Store from '../../../../../lib/store/store-v2';
import { unwrap } from '../../../../lib/playerPreferences';

export default function (apiBus) {
    const KEY = 'prefID';
    var state = Store();

    function handleResponse (resp) {
        const { inner, name, prefID, loadFailed } = unwrap(resp);
        const properties = loadFailed ? freshDefaults() : normalize(inner);

        state.set({
            isResolving: false,
            data: { name, ...properties },
            preferenceID: prefID,
            loadFailed,
        });
    }

    var apiActions = Store.ApiActions(state, KEY, {
        edit: handleResponse,
        add: handleResponse,
        getByID: handleResponse,
    });
    Store.SubscribeToApi(apiActions, apiBus);

    function init () {
        state.set({
            isResolving: false,
            data: { name: '', ...freshDefaults() },
            preferenceID: null,
            loadFailed: false,
        });
    }

    return {
        state: state,
        init: init,
    };
};
